
import React, { useState, useRef, useEffect } from 'react';
import axios from "axios";
import useAuth from '../hooks/useAuth';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button, Form, Input, message } from 'antd';

const Login = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const userRef = useRef();
    const [form] = Form.useForm();

    const [values, setValues] = useState({ username: '', password: '' });
    const [errors, setErrors] = useState({});
    const [erroLogin, setErroLogin] = useState(null);
    const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const handleLogin = async (e) => {
        e.preventDefault();
        setErroLogin('');
        console.log("Login > handleLogin > START");

        try {
            const response = await axios.post(`${baseURL}/login`, values, { withCredentials: true });

            console.log("Login > handleLogin > response.data: ", JSON.stringify(response.data));

            if (response.data.loginStatus) {
                const user_id = response?.data?.user_id;
                const group_name = response?.data?.group_name;
                const group_id = response?.data?.group_id;

                const permissionsResponse = await axios.post(`${baseURL}/group_permissions`,
                    { group_id: group_id },
                    { withCredentials: true }
                );
                const permissions = permissionsResponse.data;

                setAuth({
                    isAuthenticated: true,
                    user: values.username,
                    user_id: user_id,
                    group_id: group_id,
                    group_name: group_name,
                    permissions: permissions
                });

                console.log("Login > handleLogin > permissions: ", JSON.stringify(permissions));

                // Navigate to a PROTECTED route explicitly
                //navigate('/users', { replace: true });
                navigate('/', { replace: true }); // Redirect to welcome page

            } else {
                setErroLogin(response.data.message);
            }
        } catch (err) {
            if (!err?.response) {
                setErroLogin("Sem resposta do servidor");
            } else if (err.response?.status === 400) {
                setErroLogin("Sem utilizador ou password");
            } else if (err.response?.status === 401) {
                setErroLogin("Não autorizado");
            } else {
                setErroLogin("Login falhou");
            }
        }
    };

    const handleForgotPassword = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post(`${baseURL}/users-forgot-password`, {
                email: resetEmail
            });

            if (response.data.success) {
                //message.success('Password reset link sent to your email');
                message.success(response.data.message);
                setForgotPasswordVisible(false);
            } else {
                message.error(response.data.message);
            }
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to send reset link');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="d-flex vh-100 justify-content-center align-items-center">
            <div className="p-3 bg-white w-25">
                <div className="text-danger">{erroLogin && erroLogin}</div>
                <div className="logo-container">
                    <img
                        src="/images/app_logo1.png"
                        alt="App Logo"
                        className="login-logo"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${process.env.PUBLIC_URL}/images/app_logo1.png`;
                        }}
                    />
                </div>
                <h5>Log in to your account</h5>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label htmlFor="username">Email</label>
                        <input type="text" name="username" className="form-control" value={values.username}
                            onChange={(e) => setValues({ ...values, username: e.target.value })}
                            ref={userRef} />
                        {errors.username && <span className="text-danger">{errors.username}</span>}
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password">Password</label>
                        <input type="password" name="password" className="form-control" value={values.password}
                            onChange={(e) => setValues({ ...values, password: e.target.value })} />
                        {errors.password && <span className="text-danger">{errors.password}</span>}
                    </div>
                    <button type='submit' className="btn btn-success">Login</button>
                    <div className="mt-2">
                        <a href="#" onClick={() => setForgotPasswordVisible(true)}>Forgot Password?</a>
                    </div>
                </form>

                {/* Forgot Password Modal */}
                <Modal
                    title="Reset Password"
                    visible={forgotPasswordVisible}
                    onCancel={() => setForgotPasswordVisible(false)}
                    footer={[
                        <Button key="back"
                            className="btn btn-secondary"
                            onClick={() => setForgotPasswordVisible(false)}>
                            Cancel
                        </Button>,
                        <Button
                            key="submit"
                            className="btn btn-success"
                            loading={isLoading}
                            onClick={handleForgotPassword}
                        >
                            Send Reset Link
                        </Button>,
                    ]}
                >
                    <Form form={form} layout="vertical">
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!'
                                },
                                {
                                    type: 'email',
                                    message: 'Please enter a valid email address'
                                }
                            ]}
                        >
                            <Input
                                placeholder="Enter your registered email"
                                onChange={(e) => setResetEmail(e.target.value)}
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    );
};

export default Login;


